import { createContext, useContext } from 'react';

export interface MainCtaConfig {
  text: string;
  enabled?: boolean;
  loading?: boolean;
  onClick: () => void;
}

export interface MainCtaContextValue {
  cta: MainCtaConfig | null;
  setCta: (cta: MainCtaConfig | null) => void;
}

export const MainCtaContext = createContext<MainCtaContextValue | null>(null);

export function useMainCta(): MainCtaContextValue {
  const ctx = useContext(MainCtaContext);
  if (!ctx) throw new Error('useMainCta must be used inside <MainCtaProvider>');
  return ctx;
}
